import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import {
  SearchableLookupOption,
  SearchableLookupSelectComponent,
} from '@shared/components/searchable-lookup-select/searchable-lookup-select.component';
import { AffiliateStore } from '@features/affiliate/affiliate.store';
import { InterventionStore } from '../../../intervention.store';
import { InterventionAffiliateAssignmentResponse } from '../../../intervention.model';

@Component({
  selector: 'intervention-affiliate-assignment',
  imports: [ReactiveFormsModule, SearchableLookupSelectComponent, ...SharedMaterialUIModule],
  templateUrl: './intervention-affiliate-assignment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InterventionAffiliateAssignmentComponent {
  protected readonly affiliateStore = inject(AffiliateStore);
  protected readonly interventionStore = inject(InterventionStore);

  readonly interventionId = input.required<string>();
  readonly canAssign = input(false);
  readonly assigned = output<InterventionAffiliateAssignmentResponse>();

  protected readonly affiliateControl = new FormControl<string>('', { nonNullable: true });

  protected readonly affiliateOptions = computed<SearchableLookupOption[]>(() =>
    this.affiliateStore.affiliateLookupResponses().map((item) => ({
      id: item.id,
      name: `${item.name} ${item.surname}`.trim(),
      code: null,
    })),
  );

  constructor() {
    this.affiliateStore.loadAffiliateLookupResponses();
  }

  protected affiliateSearchChanged(search: string): void {
    this.affiliateStore.loadAffiliateLookupResponses(search);
  }

  protected assign(): void {
    const affiliateId = this.affiliateControl.value;
    if (!affiliateId) {
      return;
    }

    this.interventionStore.assignAffiliate(this.interventionId(), { affiliateId }, (assignment) => {
      this.affiliateControl.setValue('');
      this.assigned.emit(assignment);
    });
  }
}
